export const EVENT = {
  slug: 'collect-a-con-phoenix-2026-05',
  name: 'Collect-A-Con Phoenix',
  dateRange: 'May 16–17',
}

export const QR_URL =
  process.env.REACT_APP_QR_URL || 'https://nanza.app'

export const APP_STORE_URL =
  process.env.REACT_APP_APP_STORE_URL ||
  'https://apps.apple.com/us/app/nanza/id6757965694'
